var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" صفحه مورد نظر شما وجود ندارد تا چند ثانیه دیگر به صفحه اصلی منتقل میشوید ")])
}
var staticRenderFns = []

export { render, staticRenderFns }